import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

class FriendBuyAnalytics {
  static clickStartSharingAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.startSharing;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }

  static clickShareAgainAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.shareAgain;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }

  static clickSendAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.send;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }

  static clickFacebookShareAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.facebookShare;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }

  static clickMessengerShareAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.messengerShare;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }

  static clickTwitterShareAction(payload) {
    const category = GA_EVENTS.friendbuy.category;
    const action = GA_EVENTS.friendbuy.actions.twitterShare;
    const value = payload;
    const label = GA_EVENTS.friendbuy.label;

    setBehaviourEvent({ category, action, value, label });
    setFunnelyticsBehaviourEvent({ category, action, value, label });
    fbq('trackCustom', action, { value, label });
  }
}

export default FriendBuyAnalytics;
